export const validateVatNumber = (value?: string | null) => {
  const trimmed = value?.trim();
  if (!trimmed) return undefined;
  return trimmed.length === 11
    ? undefined
    : "La partita IVA deve contenere esattamente 11 caratteri.";
};
